module.exports = __webpack_public_path__ + "img/580e668.png";